import { GetPermitTransactionV2ResponseBodyDTO } from '@ketch-com/figurehead'
import { API } from 'utils/api/api'
import { formatRequestString } from 'utils/helpers/api/queryString'

type Params = {
  queryKey: [string, { transactionId: string }]
}

type Response = GetPermitTransactionV2ResponseBodyDTO

export const fetchMultiplePermitTransactions = ({ queryKey }: Params) => {
  const [, { transactionId }] = queryKey
  return API.get<Response>(
    formatRequestString({
      entityUrl: `/api/permit-transactions/${transactionId}`,
    }),
  )
}
